import {API, Setup} from '../../Services';


async function getTransactionsApi(obj,page) {
    let token =  localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId')
    return API.get(`/malls/${mallId}/transactions?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params : obj
    });
}


export {getTransactionsApi};
